import React from "react";
import MainLayout from "../../Layout/mainLayout";
const ListLogsAndAudit = () => {
  return <MainLayout>Work In Progress</MainLayout>;
};

export default ListLogsAndAudit;
